import getConfig from "next/config";

import Modal from "@components/Modal";
import Price from "@components/Price";
import Alert from "@components/Alert";
import Button from "@components/Button";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const ResealedProductStorePickupModal = ({
  resealedModalId,
  mainProduct,
  resealedProduct,
}) => (
  <Modal id={resealedModalId} header="Produsul a fost adaugat in cos">
    {resealedProduct ? (
      <>
        <div className="flex border-b border-gray-light pb-[20px]">
          <div className="w-[40%] md:w-[20%]">
            {mainProduct.thumbnail && (
              <img
                src={`${settings.cdn}/media/${mainProduct.thumbnail}`}
                className="Media-image"
                alt={mainProduct.name}
              />
            )}
          </div>

          <div className="flex flex-grow flex-col md:flex-row justify-center md:justify-between md:items-center ml-[16px]">
            <div className="text-[14px]">{mainProduct.name}</div>

            <div className="min-w-fit md:ml-[16px]">
              <Price
                size="smaller"
                formatted
                resealed
                price={resealedProduct.price.selling_price}
                regularPrice={resealedProduct.price.base_price}
                resealedLabel="Pret produs nou"
              />
            </div>
          </div>
        </div>

        <div className="mt-[20px] mb-[40px]">
          <Alert type="info" showIcon>
            Poti continua procesul de rezervare in cosul de cumparaturi.
          </Alert>
        </div>

        <Button variant="primary" title="Vezi cosul" href="/cos-cumparaturi" />
      </>
    ) : (
      <Alert type="info" showIcon>
        Momentan acest produs nu este disponibil in magazinele fizice.
      </Alert>
    )}
  </Modal>
);

export default ResealedProductStorePickupModal;
